import type { LanguageRuntime } from '../i18n/runtime';
import type { WorkerLanguageMessage } from '../i18n/workerLanguage';

export const registerServiceWorker = () => navigator.serviceWorker.register('/sw.js');

export const connectServiceWorkerLanguage = (runtime: LanguageRuntime, serviceWorker = navigator.serviceWorker) => {
  let active = true;
  const send = (worker: ServiceWorker | null) => {
    if (!active || !worker) return;
    const { preference, effectiveLocale } = runtime.getSnapshot();
    const message: WorkerLanguageMessage = { type: 'borgee:language', preference, effectiveLocale };
    worker.postMessage(message);
  };
  const sync = () => {
    send(serviceWorker.controller);
    // An installed worker may receive messages before this page is controlled.
    void serviceWorker.getRegistration('/').then(registration => send(registration?.active ?? null)).catch(console.error);
  };
  const onMessage = (event: MessageEvent) => {
    if (event.data?.type === 'borgee:language-error') {
      console.error(new Error('Unable to save the notification language on this device.'));
    }
  };
  const unsubscribe = runtime.subscribe(sync);
  serviceWorker.addEventListener('controllerchange', sync);
  serviceWorker.addEventListener('message', onMessage);
  void serviceWorker.ready.then(registration => send(registration.active)).catch(console.error);
  sync();
  return () => {
    active = false;
    unsubscribe();
    serviceWorker.removeEventListener('controllerchange', sync);
    serviceWorker.removeEventListener('message', onMessage);
  };
};
